import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBHover } from '@shared/components/hover';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface AddSubformRowProps {
  onAdd(): void;
}

export function AddSubformRow({ onAdd }: AddSubformRowProps) {
  const colors = useContext(ColorThemeContext);

  return (
    <MBTouchableOpacity onPress={onAdd}>
      <MBHover hoverStyle={{ backgroundColor: colors.input.backgroundInactive }} centerVertically>
        <View row centerVertically paddingVertical={1} paddingHorizontal={3}>
          <MBIconV2 name="plus" size={22} color={colors.foregroundActive} />
          <View fill centerVertically paddingLeft={1}>
            <MBTextBody1 color={colors.foregroundActive}>
              {i18n('workflowTemplate.createNewSubform')}
            </MBTextBody1>
          </View>
        </View>
      </MBHover>
    </MBTouchableOpacity>
  );
}
